import { render, staticRenderFns } from "./BookingNearestDriverSummaryV2.vue?vue&type=template&id=e496da54&"
import script from "./BookingNearestDriverSummaryV2.vue?vue&type=script&lang=js&"
export * from "./BookingNearestDriverSummaryV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports